<template>
  <v-row>
    <v-card class="w-full pa-2 mx-4">
      <span class="f-bold f-s-xs">{{ $t("TicketMultiTrip") }}</span>
      <hr />

      <div class="d-flex flex-row justify-between">
        <div class="d-flex flex-column">
          <span class="f-bold f-s-xs">{{ fareName }}</span>
          <span class="f-s-xs">{{ maxTrip + ' ' + $t("Kali Perjalanan")}}</span>
        </div>
        <div class="pr-price">
          <span class="num-135000-v-nd break-word">
            {{ new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: selectedCurrency,
            minimumFractionDigits: 2
            }).format(lastprice) }}
          </span>
        </div>
      </div>

      <div class="d-flex flex-row justify-between" style="gap: 16px">
        <v-col class="d-flex justify-center pa-0" style="flex: 1; align-items: center; height: 40px;">
          <ac-button 
            :small="true"
            :outlined="true"
            :name="$t('DetailTicket')" 
            :on-click-handler="clickRouteInformation"
          />
          <!-- <v-btn
            v-if="$partnerACL.isShowButton('detail')"
            class="text-capitalize btn-buy-hijau"
            v-on:click="clickView"
            rounded
            outlined
            min-width="70px"
            :color="$partnerACL.getButtonColor()"
            :style="`color:${$partnerACL.getButtonColor()}`"
            small
          >
            {{ $t("ViewTicket") }}
          </v-btn> -->
        </v-col>
        <v-col class="d-flex justify-center pa-0" style="flex: 0; align-items: center; height: 40px;">
          <div class="class-btn-buy" v-if="buy == false">
            <ac-button 
              :small="true"
              :name="$t('Buy')" 
              :on-click-handler="clickBuy"
              :width="'78px'"
            />
          </div>
          <div v-if="buy == true" class="group-18785" :style="`border:1px solid ${$partnerACL.getButtonColor()}`">
            <ac-button 
              :fab="true"
              :outlined="true"
              class-btn="btn-plus"
              :name="'+'" 
              :on-click-handler="mpplus"
            />
            <ac-button 
              :fab="true"
              :outlined="true"
              class-btn="btn-minus"
              :name="'-'" 
              :on-click-handler="mpminus"
            />
            <input class="label input-label" v-model="newValue" disabled :style="`color:${$partnerACL.getButtonColor()}`"/>
          </div>
        </v-col>
      </div>
    </v-card>
  </v-row>
</template>

<script>
import AcButton from "@/components/AcButton";

export default {
  name: "CardBuyMultiTrip",
  components: { AcButton },
  lastprice: "",
  props: {
    price: { 
      type: Number, 
      default: 0 
    },
    currencyCode: { 
      type: String, 
      default: "" 
    },
    fareID: { 
      type: String, 
      default: "-" 
    },
    fareType: { 
      type: Number, 
      default: 3 
    },
    fareName: { 
      type: String, 
      default: "fareName" 
    },
    maxTrip: { 
      type: Number, 
      default: 0 
    },
    maxTripPerDay: { 
      type: Number, 
      default: 0 
    },
    validDays: { 
      type: Number, 
      default: 0 
    },
    expiredAfterUsage: { 
      type: Number, 
      default: 0 
    },
    routeInformation: {
      type: Object,
    },
    clickInformation: {
      /*  set handler function after click oke/ yes
       */
      type: Function,
      required: false,
    },
    value: {
      default: 0,
      type: Number,
    },
    min: {
      default: 1,
      type: Number,
    },
    max: {
      default: undefined,
      type: Number,
    },
    newValues: { 
      type: Number, 
      default: 0 },
    reset: { 
      type: Boolean, 
      default: false },

    keyItem: { 
      type: String },
  },
  data() {
    return {
      newValue: this.newValues,
      buy: this.reset,
    };
  },
  created: function () {
    this.newValue = this.value;
    this.lastprice = this.price;
  },
  computed: {
    selectedCurrency() {
      return this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.code : ""
    },
  },
  methods: {
    clickRouteInformation() {
      this.$store.commit("moduleUi/ROUTE_INFORMATION", this.routeInformation);
      this.clickInformation();
    },
    clickBuy() {
      this.buy = true;
      this.$emit("buy", true);
      this.mpplus();
    },
    mpplus: function () {
      if (this.max === undefined || this.newValue < this.max) {
        this.newValue = this.newValue + 1;
        this.$emit("input", this.newValue);
        this.lastprice = this.price * this.newValue;
      }
    },
    mpminus: function () {
      if (this.newValue > this.min) {
        this.newValue = this.newValue - 1;
        this.$emit("input", this.newValue);
        this.lastprice = this.price * this.newValue;
      } else {
        this.buy = false;
        this.newValue = this.newValue - 1;
        this.$emit("input", this.newValue);
        this.$emit("buy", false);
        this.lastprice = this.price;
      }
    },
  },

  watch: {
    value: {
      handler: function (newVal) {
        this.newValue = newVal;
      },
      validate_end_date() {
        this.validate_end_date = moment(
          this.validate_end_date,
          "DD-MM-YYYY"
        ).format("DD/MM/YYYY");
      },
    },
    reset() {
      this.buy = false;
      this.newValue = 0;
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}

.pr-price {
    height: 35px;
    align-content: center;
}

.num-135000-v-nd {
  // @include roboto-14-medium;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #fe7e41;
}

.group-18785 {
    border-radius: 23px;
    height: 29px;
    width: 78px;
    padding: 5px 6px 2px 4px;
    position: relative;
}

.btn-plus {
    top: -5px;
    height: 28px !important;
    width: 28px !important;
    font-size: 20px;
    z-index: 2;
    left: 45px;
}

.btn-minus {
    top: -5px;
    height: 28px !important;
    width: 28px !important;
    z-index: 2;
    font-size: 20px;
    left: -33px;
}

.label {
  width: 64px;
  // @include roboto-10-bold;
  color: rgba(75, 177, 78, 1);
  text-align: center;
  position: relative;
}

.input-label {
  top: -30px;
}
</style>